<template>
  <div
    class="tw-flex tw-h-8 tw-flex-none tw-rounded-lg tw-transition-all"
    :class="{
      'tw-w-[240px] tw-border tw-bg-white focus-within:tw-border-deep-orange-600 dark:tw-bg-black': isOpen,
      'tw-w-8 tw-items-center tw-justify-center tw-border hover:tw-border-deep-orange-50 hover:tw-bg-deep-orange-50 hover:tw-text-deep-orange-600':
        !isOpen,
      '!tw-w-full': alwaysExpanded
    }"
  >
    <button
      data-testid="studio-search-button"
      :class="{
        'tw-inline-flex tw-h-8 tw-w-8 tw-flex-none tw-items-center tw-justify-center tw-rounded-lg': true,
        'tw-tw-cursor-default hover:tw-text-deep-orange-600': isOpen,
        'hover:tw-border-deep-orange-50 hover:tw-bg-deep-orange-50 hover:tw-text-deep-orange-600': !isOpen
      }"
      @click="toggleInput"
    >
      <TablerSearch class="tw-mt-0 tw-h-5 tw-w-5" />
    </button>
    <input
      v-show="isOpen"
      ref="searchInput"
      data-testid="studio-search-input"
      type="search"
      class="tw-h-8 tw-w-full tw-self-stretch tw-overflow-visible tw-rounded-full tw-border-none tw-bg-transparent tw-pl-1 tw-pr-1 tw-text-sm tw-leading-4 focus:tw-border-none focus:tw-outline-none focus:tw-ring-0"
      :value="searchTerm"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
    />
  </div>
</template>

<script lang="ts">
import debounce from 'lodash.debounce';
import { defineComponent, nextTick } from 'vue';

import TablerSearch from './Icons/tabler/TablerSearch.vue';

type InputRef = InstanceType<typeof HTMLInputElement>;

export default defineComponent({
  name: 'StudioSearchInput',
  components: { TablerSearch },
  props: {
    searchTerm: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search...'
    },
    alwaysExpanded: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      isOpen: false
    };
  },
  mounted() {
    if (this.searchTerm || this.alwaysExpanded) {
      this.isOpen = true;
    }
  },
  watch: {
    isOpen: function (newIsOpen) {
      if (newIsOpen && this.$refs.searchInput) {
        nextTick(() => {
          (this.$refs.searchInput as InputRef)?.focus();
        });
      }
      if (!newIsOpen && this.searchTerm) {
        this.$emit('onSearch', '');
      }
    },
    searchTerm: function (newValue) {
      if (newValue) {
        this.isOpen = true;
      }
    }
  },
  methods: {
    onInput: debounce(function (event) {
      const newSearchTerm = event.target.value;
      // @ts-ignore
      this.$emit('onSearch', newSearchTerm.trim());
    }, 1000),

    toggleInput() {
      if (this.alwaysExpanded) {
        return;
      }
      this.isOpen = !this.isOpen;
    }
  }
});
</script>
